_ = require('underscore')

util = {}

# classify vm
util.classifyRE = /(?:^|[-_])(\w)/g
util.classify = (str) ->
  str.replace(util.classifyRE, (c) -> c.toUpperCase()).replace(/[-_]/g, '')

# location formating
util.formatLocation = (str) ->
  str += '- use the "name" option for better debugging messages.' if str == '<Anonymous>'
  return "\n(found in #{str})"

# name formating
util.formatComponentName = (vm) ->
  return '<Root>' if vm.$root == vm

  name = if vm._isVue then vm.$options.name || vm.$options._componentTag else vm.name
  file = vm._isVue && vm.$options.__file

  if !name && file
    match = file.match(/([^\/\\]+)\.vue$/)
    name  = match && match[1]

  name = if name then "<#{util.classify(name)}>" else '<Anonymous>'
  name = "#{name} at #{file}" if file?
  name

# vue warning message
util.vueWarn = _.noop
if process.env.NODE_ENV != 'production'
  util.vueWarn = (msg, vm) ->
    if typeof console != 'undefined'
      console.error "[Vue warn]: #{msg} #{if vm? then util.formatLocation(util.formatComponentName(vm)) else ''}"

# export
module.exports = util


// WEBPACK FOOTER //
// ./assets/js/shared/plugins/vue_rollbar/util.coffee